<template>
  <path
    d="M8 19.0002H16C16.55 19.0002 17 18.5502 17 18.0002V5.00024C17 4.45024 16.55 4.00024 16 4.00024H8C7.45 4.00024 7 4.45024 7 5.00024V18.0002C7 18.5502 7.45 19.0002 8 19.0002ZM3 17.0002H5C5.55 17.0002 6 16.5502 6 16.0002V7.00024C6 6.45024 5.55 6.00024 5 6.00024H3C2.45 6.00024 2 6.45024 2 7.00024V16.0002C2 16.5502 2.45 17.0002 3 17.0002ZM18 7.00024V16.0002C18 16.5502 18.45 17.0002 19 17.0002H21C21.55 17.0002 22 16.5502 22 16.0002V7.00024C22 6.45024 21.55 6.00024 21 6.00024H19C18.45 6.00024 18 6.45024 18 7.00024Z"
  />
</template>
